namespace RedBullMOBILE360.CVM {
    export interface SegmentCriteriaRow {
        Id?: number;
        SegmentId?: number;
        ConditionId?: number;
        SegmentTitle?: string;
        SegmentOfferId?: string;
        ConditionName?: string;
        Condition?: string;
    }

    export namespace SegmentCriteriaRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'CVM.SegmentCriteria';
        export const deletePermission = 'CVM:SegmentCriteria';
        export const insertPermission = 'CVM:SegmentCriteria';
        export const readPermission = 'CVM:SegmentCriteria';
        export const updatePermission = 'CVM:SegmentCriteria';

        export declare const enum Fields {
            Id = "Id",
            SegmentId = "SegmentId",
            ConditionId = "ConditionId",
            SegmentTitle = "SegmentTitle",
            SegmentOfferId = "SegmentOfferId",
            ConditionName = "ConditionName",
            Condition = "Condition"
        }
    }
}
